<template>
    <b-navbar
      toggleable="lg"
      style="background: #ffffff; padding-left: 5%; padding-right: 5%; box-shadow: 0px 5px 5px rgba(189, 195, 199, 0.15);"
      :sticky="true"
    >
      <b-navbar-brand to="/">
        <img src="@/assets/protelLogo.png" style="width: 100px;" alt="" />
      </b-navbar-brand>
      <b-navbar-toggle target="nav-collapse">
       </b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav right>
        <b-navbar-nav class="ml-auto">
          <b-nav-item v-on:click="scroll(1)">
            <span class="navItem"> {{ $t('navBar1') }} </span>
          </b-nav-item>
          <b-nav-item>
            <router-link style="text-decoration: none; color: #2c3e50;" :to="{ name: 'Integrations', params: {}}">
              <span class="navItem"> {{ $t('navBar2') }} </span>
            </router-link>
          </b-nav-item>
          <b-nav-item v-on:click="scroll(2)">
            <span class="navItem"> {{ $t('navBar3') }} </span>
          </b-nav-item>
          <b-nav-item>
            <router-link style="text-decoration: none; color: #2c3e50;" :to="{ name: 'Contact', params: {}}">
              <span class="navItem"> {{ $t('navBar4') }} </span>
            </router-link>
          </b-nav-item>
          <!-- <b-nav-item to="/Alphabet"> <span class="navItem"> {{ $t('alphabet') }} </span> </b-nav-item> -->
          <b-nav-item-dropdown text="Right align" no-caret right>
            <template #button-content>
              <span class="navItem">
                {{ $t('navBar5') }}
              </span>
            </template>
              <b-dropdown-item class="ddItem" v-for="lang in langList" :key="lang.id" @click="$i18n.locale = lang.code"> 
                {{ lang.name }}
              </b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
</template>

<script>

export default {
  name: "Navbar",
  data() {
    return {
    langList: [{"name": "English", "code": "en"}, {"name": "Georgian", "code": "ge"}],
    };
  },
  async mounted() {
  
  },

  methods: {
    scroll(id) { 
      if (this.$router.currentRoute.name != "Landing") {
        this.$router.push({ name: 'Landing', params: { id: id } });
      } else {
        document.getElementById(id).scrollIntoView({
        behavior: "smooth"
      });
      }
    },
  },

  components: {
  },
  props: {},

  computed: {
  },
};
</script>

<style scoped>
.navItem {
  color: black;
  display: inline-block;
  font-size: 0.875rem;
  padding-bottom:2px;
  background-image: linear-gradient(red, red);
  background-position: 0 100%; /*OR bottom left*/
  background-size: 0% 2px;
  background-repeat: no-repeat;
  transition:
  background-size 0.3s,
  background-position 0s 0.3s; /*change after the size immediately*/
}
.navItem:hover {
 background-position: 100% 100%; /*OR bottom right*/
  background-size: 100% 2px;
}

.ddItem {
  text-align: right;
}



/* @media only screen and (max-width: 770px) {
  body{
    background: #212529;
  }
  .navDiv2{
    width: 100%;
    height: 60px;
    color: white;
    background: #1b1d20;  
}
  .MobileHide {
    display: none;
  }
}

@media only screen and (min-width: 770px) {
  .MobileShow {
    display: none;
  }

} */
</style>
